import React,{useState, useEffect} from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import Images from "../../../media/images";
import UpdateEmployee from "./UpdateEmployee";

const ListEmployee = () => {
  const [employeeList, setEmployeeList] = useState([])
  const [empId, setEmpId] = useState(null)
  const [change, setChange] = useState(true)


  useEffect(() => {
   api.get('/info/employee-details/')
   .then(response=> {
    setEmployeeList(response.data)
   }).catch(error=> {
     
   })
  }, [change])


  const handleDelete = (id) => {
    api.delete(`/info/employee-details/${id}/`)
    .then(response=> {
       let arr = employeeList.filter((item)=> item.id !== id)
       setEmployeeList(arr)
       toast.success("Deleted Successfully")
    }).catch(error=> {

    })
  }
  

  return (
    <div>
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        List Employee
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>

      <div className="px-10">
        <table className="min-w-full text-center">
          <thead className="font-Bree bg-primary-red border-b font-bold">
            <tr>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                SN.
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Name
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Designation
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Contact Number
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Email
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody className="font-Acme">

            {
              employeeList?.map((item, i)=> {
                return(
                  <tr className="border-b bg-white">
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                    {i+1}
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                    {item.name}
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                    {item.designation}
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                    {item.contact_number} 
                  </td>
                  <td>{item.email}</td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                    <button
                    className="bg-primary-red rounded-full p-1 px-2 text-white"
                    data-bs-toggle="modal"
                    data-bs-target="#UpdateEmployeeModalDemo"
                    > 
                       Update
                    </button>

                    <UpdateEmployee item={item} setChange={setChange} change={change}/>
    
                    <button className="bg-primary-red rounded-full p-1 px-2 text-white"
                    onClick={()=> handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
                )
              })
            }
           
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListEmployee;
